<template>
    <div class="accordion">
        <div v-ripple class="header border-bottom" @click="collapsed=!collapsed">
            <h5 class="title">
                {{title | validate }}
            </h5>
            <span class="icon mdi mdi-chevron-down"
                  :class="{'mdi-chevron-down':collapsed,'mdi-chevron-up':!collapsed}"></span>
        </div>
        <div class="body" :class="{collapsed: collapsed}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "accordion2",
        props: {
            collapsed: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: "Title"
            }
        },
        data() {
            return {
                isCollapsed: false,
            }
        },
        methods: {}
    }
</script>

<style scoped lang="scss">
    @import "../styles/main";

    $padding: 8px;

    .accordion {
        background-color: $white;
        border: 1px solid $black-1;
        .header {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 0 $padding*2;
            cursor: pointer;
            .title {
                font-size: 18px;
                margin: 0;
            }
            .icon {
                font-size: 24px;
            }
        }
        .body {
            padding: 4px $padding;
            transition: height 0.2s;
            &.collapsed {
                height: 0;
                overflow: hidden;
                padding: 0;
            }
        }
    }

    .border-bottom {
        border-bottom: 1px solid $black-1;
    }
</style>